import React, {Component} from 'react';
import { AutoComplete } from "antd";

/**
 * 自动完成
 */
class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataList: this.props.data.data ? this.props.data.data : [],
        };
    }

    render() {
        let {data} = this.props;
        let {dataList} = this.state;
        return (
            <div>
                {(data.purpose == "edit" || !data.purpose) ?
                    <AutoComplete
                        {...this.props.option}
                        options={dataList}
                        onChange={(value) => {
                            //输入值事件校对回调
                            this.props.verification(this.props.data, value)
                        }}

                    /> : <div>
                        {data.option && data.option.defaultValue}
                    </div>
                }
            </div>
        );
    }
}


export default  Index;